// Angular
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
// Service
import { CartService, CommonService } from '@core/utils';
// Component
import { QuickCartViewComponent } from '../quick-panels/quick-cart-view/quick-cart-view.component';
// Modules
import { TranslocoDirective } from '@jsverse/transloco';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-quick-cart-counter',
    templateUrl: './quick-cart-counter.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective]
})
export class QuickCartCounterComponent {

    // Private
    private readonly offcanvasService = inject(NgbOffcanvas);
    private readonly commonService = inject(CommonService);
    private readonly cartService = inject(CartService);


    // Signal 
    count = this.cartService.cartCountSignal;

    /**
     * Open Quick Cart View
     * @memberof QuickCartCounterComponent
     */
    onOpenQuickCart(): void {
        const modalRef = this.offcanvasService.open(QuickCartViewComponent, { position: 'end' });
        modalRef.componentInstance.commonService = this.commonService;
    }

}
